import React from 'react';
import MessageList from '@src/components/OrcaExternal/Messages/MessageList';

/**
 * The team's messages, which are the same list the messages resource shows —
 * one list, reachable from the team page as well as from its own route, rather
 * than two that have to be kept in step.
 */
const MessagesTab = () => (
    <div className="tm-tab">
        <MessageList resource="serviceowner_messages" basePath="/serviceowner_messages" />
    </div>
);

export default MessagesTab;
